const API_HOST = window.NFT?.api_host

export const fetchCitiesByCountry = async countryCode => {
  if (!countryCode) return
  const url = API_HOST + '/catalog/api/v1/cities/' + countryCode;

  const citiesFromCache = sessionStorage.getItem(url);
  if (citiesFromCache) return JSON.parse(citiesFromCache);

  const response = await fetch(url)

  if (!response.ok) {
    /* eslint-disable-next-line no-console */
    console.error('Error fetching cities')
    return []
  }
  const cities = await response.json()
  sessionStorage.setItem(url, JSON.stringify(cities))
  return cities
}

export const requestAccountConfirmation = async () => {
  const url = AD?.resend_confirmation_email_uri;
  if (!url) {
    // eslint-disable-next-line no-console
    console.error('Resend Confirmation URI not found')
    return
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return response.ok
} 
